
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export const useTaxRate = (isOpen?: boolean) => {
  const [taxRate, setTaxRate] = useState<number>(10); // Default to 10% if setting not found

  useEffect(() => {
    const fetchTaxRate = async () => {
      try {
        const { data, error } = await supabase
          .from('settings')
          .select('value')
          .eq('variable_name', 'tax_rate')
          .maybeSingle();

        if (error) {
          console.error('Error fetching tax rate:', error);
          return;
        }

        if (data) {
          // Store the tax rate as a whole number (e.g., 10 for 10%)
          const rate = data.value;
          console.log('Tax rate from settings:', rate);
          setTaxRate(rate);
        } else {
          console.log('Tax rate setting not found, using default 10%');
        }
      } catch (error) {
        console.error('Unexpected error fetching tax rate:', error);
      }
    };

    // If isOpen is undefined or true, fetch the tax rate
    if (isOpen === undefined || isOpen) {
      fetchTaxRate();
    }
  }, [isOpen]);

  return { taxRate };  // Return an object with taxRate property
};
